import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { AlbumConversionService } from '../../conversion/album/album-conversion.service';
import { Album, Empty } from 'src/app/libs/proto/commUnity_pb';
import { Observable } from 'rxjs';
import * as grpcWeb from 'grpc-web';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class GrpcAlbumLibService{
  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: AlbumConversionService,
  ){}

  getAlbum(option?: GrpcLibServiceOption): Promise<Album[]>{
    return new Observable<Album[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getAlbumOffline(opt);
      } else {
        this._getAlbumOnline(opt);
      }
    }).toPromise();
  }
  private _getAlbumOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('album-s') || this.storLib.get('album')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getAlbumOnline(option: GrpcLibServiceOption){
    const t = this.userLib.Data.token?.getToken();
    this.grpcLib.MobileClient.getAlbums(new Empty(), {
        token: t,
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getAlbumOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getAlbumOnlineStatus(s, option);
      })
      .on('data', (r: Album) => {
        this._getAlbumOnlineData(r, option);
      })
      .on('end', () => {
        this._getAlbumOnlineEnd(option);
      });
  }

  private _getAlbumOnlineData(ret: Album, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getAlbumOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getAlbumOnline(option);
    }, option);
  }

  private _getAlbumOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getAlbumOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.album = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'album', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }

    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getAlbumOnline(option);
      }, option);
    }
  }
}





